import Toast from "@/common/components/ui/toast";
import { ToastProvider } from "@/common/components/ui/toast/toast.provider";
import PreCollectionForm from "./PreCollection";

export function PreCollection() {
  return (
    <ToastProvider>
      <PreCollectionForm />
      <Toast />
    </ToastProvider>
  );
}